import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

const styles = {};

const enhance = compose(pure);

const button = enhance(
  ({
    value,
    firstValue,
    firstLabel,
    SecondValue,
    SecondLabel,
    onClickActionFirst,
    onClickActionSecond
  }) => {
    return (
      <ToggleButtonGroup value={value}>
        <ToggleButton value={firstValue} onClick={onClickActionFirst}>
          {firstLabel}
        </ToggleButton>
        <ToggleButton value={SecondValue} onClick={onClickActionSecond}>
          {SecondLabel}
        </ToggleButton>
      </ToggleButtonGroup>
    );
  }
);

export default withStyles(styles)(button);
